import axios from 'axios';
import { loginStatusUrl } from './interfaceUrl';

/**
 * 
 * @param {string} url url地址
 * @param {string} type 请求方式 get/post
 * @param {object} params 参数对象 
 * @param {string} headers 请求头参数 
 * @param {Array} paramsArr 参数数组
 * @returns 
 */
// axios全局设置是否允许携带cookie
axios.defaults.withCredentials = true;
const axiosRequest = (url, type = 'get', params = {}, headers = {}, paramsArr = []) => {
	let requirtSelf = null
	if (type === 'post') {
		//paramsArr数组有值时说明参数为数组类型，否则为对象
		let data = paramsArr.length > 0 ? paramsArr : params
		requirtSelf = axios({
			method: type,
			headers: {
				...headers,
			},
			url,
			data
		})
	} else {
		requirtSelf = axios.get(url, { params, headers })
	}

	return new Promise((resolve, reject) => {
		requirtSelf.then(res => {
			if (type === 'post') {
				resolve(res)
			}
			if (res.status === 200) {
				if (res.data.success) {
					if (type !== 'post') {
						resolve(res)
					}
				} else {
					resolve(res)
				}
			} else {
				resolve(res)
				//异常处理
			}
		}).catch(error => {
			// let res = error.response
			// if (res.status === 401) {
			// //登录失效
			// } else {
			// //服务器异常
			// }
			reject(error)
		})
	})
}

// 本地存储
const LocalstorageFn = (props) => {
	const { type, key, value = '' } = props;
	switch (type) {
		case 'set':
			localStorage.setItem(key, value);
			break;
		case 'get':
			return localStorage.getItem(key);
		case 'delete':
			localStorage.removeItem(key);
			break;
		default:
			break;
	}

}

/**
 * 获取url地址参数值
 * @param {string} url url参数地址 
 * @param {string} variable 需要获取的参数名称
 * @returns 
 */
const getQueryFn = (url, variable) => {
	let query = url.split('?')[1]
	let vars = query.split('&')
	for (let i = 0; i < vars.length; i++) {
		let pair = vars[i].split('=')
		if (pair[0] === variable) {
			return pair[1]
		}
	}
	return null
}

//获取用户登录状态
const loginStatus = async () => {
	const { data } = await axiosRequest(loginStatusUrl, 'get', {}, {})
	return data;
}
//获取cookie
const cookie = {
  get(keys) {
    const mat = new RegExp(`(^|[^a-z])${keys}=(.*?)(;|$)`, 'i').exec(document.cookie);
    return mat ? decodeURIComponent(mat[2]) : '';
  },
  set(params) {
    const { name, value, expires, path, domain, secure } = params;
    let cookieText = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
    if (expires instanceof Date) {
      cookieText += `; expires=${expires.toUTCString()}`;
    }
    if (path) {
      cookieText += `; path=${path}`;
    }
    if (domain) {
      cookieText += `; domain=${domain}`;
    }
    if (secure) {
      cookieText += '; secure';
    }
    document.cookie = cookieText;
  }
};
export {
	axiosRequest,
	LocalstorageFn,
	getQueryFn,
	loginStatus,
	cookie
}